<template>
    <span class="link-lov-text">{{name}}</span>
</template>

<script>

    export default {
        name: "link-lov-text",
        props: {
            type: {type: String, require: true},                                        //值列表类型
            val: {require: true},                                                       //值列表值
        },
        watch: {
            type() {
                this.reset();
            },
            val() {
                this.reset();
            },
        },
        data() {
            return {
                name: null,
            }
        },
        methods: {
            async reset() {
                this.name = await this.$lov.getNameByTypeAndVal(this.type, this.val)
            },
        },
        mounted() {
            this.reset()
        },
    }
</script>

<style lang="scss">
    .link-lov-text {
        box-sizing: border-box;
    }
</style>
